// extracted by mini-css-extract-plugin
export default {"container":"XLKRl-k","threeLineLayout":"_3q-ZUud","originalPrice":"qU9n4CQ","markedDown":"_1swt2Qk","price":"_16nzq18"};